import { YoApi } from '@yooink/yorestapi/frontend/es/YoApi';

class UsersApi extends YoApi {
	async sendRestorePasswordLink(id) {
		const { data } = await this.axios.patch(
			this.getUrl(id, 'sendRestorePasswordLink')
		);
		return data;
	}

	async sendConfirmMailLink(id) {
		const { data } = await this.axios.patch(
			this.getUrl(id, 'sendConfirmMailLink')
		);
		return data;
	}

	async sendFollowUpInactiveClient(id) {
		const { data } = await this.axios.patch(
			this.getUrl(id, 'sendFollowUpInactiveClient')
		);
		return data;
	}

	async tryCreateMSCounterParty(id) {
		return this.simpleRequest(
			'post',
			id,
			'integrations',
			'ms',
			'create',
			{}
		);
	}

	async rejectPartnerRequest({ user, request }) {
		return this.simpleRequest('post', user, 'partnerRequest', 'reject', {
			requestId: request
		});
	}

	acceptPartnerRequest({ user, request }) {
		return this.simpleRequest('post', user, 'partnerRequest', 'accept', {
			requestId: request
		});
	}

	async quickRegister(params) {
		return this.simpleRequest('put', 'quickRegister', params);
	}

	async fetchSavedDeliveryMethods(user) {
		return this.simpleRequest('get', user, 'savedDeliveryMethods', {});
	}
}

export default new UsersApi({
	apiVersion: 'v2',
	endPoint: 'users'
});
